<template>
    <div class="listFeedBack">
        <div class="titlePage">Listado de Monitoreos {{this.feedbackArea}}</div>
         <modal
            name="FeedBackModal"
            width="50%"
            height="auto"
            :scrollable="true"
            :adaptive="true"
            :clickToClose="false"
            style="overflow:scroll"
        >
            <div class="dataInternal">
                <va-notification color="danger" v-if="refNoArea" class="refNoData">No tiene permisos para generar una retroalimentación a nuestros asesores.</va-notification>
                <ValidationObserver ref="obsFieldsArea">
                    <FormAreaSelect
                        :FieldsForm="AreaForm"
                        :ModelForm="AreaModelForm"
                        :method="executeProcess"
                        v-if="renderComponent1"
                    />
                </ValidationObserver>
            </div>
        </modal>
        <va-notification color="danger" v-if="refNoArea" class="refNoData">No tiene permisos para generar una retroalimentación a nuestros asesores.</va-notification>
        <div class="listData" v-if="this.noDtaForm">
            <FeedBackList
                :InfoView="this.DLDataList"
                :HeadTable="this.HDDataList"
                :method="executeProcess"
                :TypeFeed="this.DLDataType"
                v-if="renderComponent2"
            />
        </div>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import FeedBackList from '@/components/data-tables/DataFeedBackList.vue'
import FormAreaSelect from '@/components/forms/Forms.vue'

export default {
  name: 'listFeedBack',
  components: {
    FormAreaSelect,
    FeedBackList,
  },
  data () {
    return {
      feedbackArea: '',
      refNoArea: false,
      ListArea: [],
      datFeedBack: [],
      renderComponent1: false,
      renderComponent2: false,
      AreaModelForm: {
        IdSelectArea: '',
      },
      DLDataList: [],
      DLDataType: [],
      HDDataList: [
        {
          name: 'IdFeedBack',
          title: 'Id',
          width: '5%',
        },
        {
          name: 'DocAudit',
          title: 'Doc. Auditor',
          width: '10%',
        },
        {
          name: 'NameAudit',
          title: 'Auditor',
          width: '20%',
        },
        {
          name: 'DocAsesor',
          title: 'Doc. Asesor',
          width: '10%',
        },
        {
          name: 'NameAssesor',
          title: 'Asesor',
          width: '20%',
        },
        {
          name: 'TypeAudit',
          title: 'Tipo Monitoreo',
          width: '20%',
        },
        {
          name: 'DateAudit',
          title: 'Fecha Monitoreo',
          width: '20%',
        },
        {
          name: 'DateTransaction',
          title: 'Fecha Transacción',
          width: '20%',
        },
        {
          name: '__slot:attach',
          title: 'Detalle',
          dataClass: 'text-center',
          width: '10%',
        },
      ],
      AreaForm: [
        {
          id: 'titleArea',
          name: 'Seleccione el area donde realizara la retroalimentación',
          type: 'title',
          class: 'col-md-12',
        },
        {
          id: 'IdSelectArea',
          model: 'IdSelectArea',
          name: 'Seleccione Area',
          type: 'Select',
          placeholder: 'Seleccione Area',
          class: 'col-md-12',
          values: [],
          validate: {
            required: true,
          },
        },
        {
          id: 'Cancel_Button',
          type: 'button',
          placeholder: 'Cancelar',
          class: 'col-md-6',
        },
        {
          id: 'Area_Button',
          type: 'button',
          placeholder: 'Seleccionar',
          class: 'col-md-6',
        },
      ],
      noDtaForm: false,
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      if (refer === 'Detail') {
        this.$router.push('FeedBackForm/' + event.rowData.IdFeedBack + '/' + event.rowData.IdArea)
      } else {
        switch (event.target.id) {
          case 'btn_Area_Button':
            this.$refs.obsFieldsArea.validate().then(results => {
              if (results) {
                this.validateRol()
              }
            })
            break
          case 'btn_Cancel_Button':
            this.$router.push('admin/')
            break
        }
      }
      return true
    },
    callDataForm () {
      let loaderForm = this.$loading.show()
      var datForm = IberoHelpers.getAreaListByPerson(this.$store, this.ListArea[this.AreaModelForm.IdSelectArea].IdArea, this.RolArea, this.$session.get('IberoJWTAdminLogin').idPerson)
      datForm.then(Response => {
        if (Response.data) {
          this.datFeedBack = Response.data[0]
          this.DLDataList = Response.data[0].ListFeedBack
          for (var i = 0; i < Response.data[0].TypeFeedBack.length; i++) {
            this.DLDataType.push({ id: i + 1, description: Response.data[0].TypeFeedBack[i].TypeName })
          }
          this.renderComponent1 = false
          this.noDtaForm = true
          IberoHelpers.forceRerender2(this)
          loaderForm.hide()
        }
      })
    },
    validateRol () {
      var refRolArea = this.ListArea[this.AreaModelForm.IdSelectArea].RolByArea.find(function (element) {
        return element.Cod_Role === 'SUP'
      })
      if (refRolArea === undefined) {
        this.refNoArea = true
      } else {
        this.feedbackArea = this.ListArea[this.AreaModelForm.IdSelectArea].NamArea
        this.RolArea = refRolArea.Cod_Role
        this.$modal.hide('FeedBackModal')
        this.callDataForm()
      }
    },
    loadTypeForm () {
      this.refNoArea = false
      let loader = this.$loading.show()
      var datArea = IberoHelpers.getAreaByPerson(this.$store, this.$session.get('IberoJWTAdminLogin').idPerson)
      debugger
      datArea.then(Response => {
        if (Response.data) {
          this.ListArea = Response.data
          if (Response.data.length > 1) {
            for (var i = 0; i < Response.data.length; i++) {
              this.AreaForm[1].values.push(
                { id: i, value: Response.data[i].NamArea }
              )
            }
            IberoHelpers.forceRerender1(this)
            this.$modal.show('FeedBackModal')
            this.ListArea = Response.data
          } else {
            this.AreaModelForm.IdSelectArea = 0
            this.validateRol()
          }
        } else {
          this.refNoArea = true
        }
        loader.hide()
      })
    },
  },
  created: function () {
    this.loadTypeForm()
  },
}
</script>

<style scoped>
.dataInternal {
    padding: 20px;
    margin: 20px;
}
</style>
